// extracted by mini-css-extract-plugin
export default {"root":"kucNWb9","description":"t7MIJ0B","title":"I7bdlqa","mainInfo":"LI81U4v","logoContainer":"bgU+ihe","cell":"FXTwPGh"};